import { BrowserModule } from '@angular/platform-browser'
import { HttpClientModule } from '@angular/common/http'
import { InlineSVGModule } from 'ng-inline-svg'
import { NgModule } from '@angular/core'
import { MarkdownToHtmlModule } from 'markdown-to-html-pipe'
import {SlideshowModule} from 'ng-simple-slideshow'
import { DynamicModule } from 'ng-dynamic-component'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { NavComponent } from './components/nav/nav.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { StoryblokDirective } from './storyblok.directive'
import { StoryblokService } from './services/storyblok.service'
import { IntroComponent } from './components/intro/intro.component'
import { PageComponent } from './components/page/page.component'
import { ProjectListComponent } from './components/project-list/project-list.component'
import { AboutComponent } from './components/about/about.component'
import { InViewportModule } from 'ng-in-viewport';
import { NgInitDirective } from './ng-init.directive';
import { NetworkComponent } from './components/network/network.component';
import { MapComponent } from './components/map/map.component';
import { ContactComponent } from './components/contact/contact.component';
import { FormsModule }   from '@angular/forms';

import { TeximateModule } from 'ngx-teximate';
import { LinkedinFeedComponent } from './components/linkedin-feed/linkedin-feed.component';
import { IntroScreenComponent } from './components/intro-screen/intro-screen.component';
import { ProjectPageComponent } from './components/project-page/project-page.component';
import { HomeComponent } from './components/home/home.component';
import { ProjectContactComponent } from './components/project-contact/project-contact.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    StoryblokDirective,
    IntroComponent,
    PageComponent,
    ProjectListComponent,
    AboutComponent,
    NgInitDirective,
    NetworkComponent,
    MapComponent,
    ContactComponent,
    LinkedinFeedComponent,
    IntroScreenComponent,
    ProjectPageComponent,
    HomeComponent,
    ProjectContactComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    MarkdownToHtmlModule,
    SlideshowModule,
    InViewportModule,
    HttpClientModule,
    FormsModule,
    TeximateModule,
    InlineSVGModule.forRoot(),
    DynamicModule.withComponents([
      ProjectPageComponent,
      PageComponent,
      IntroComponent,
      ProjectListComponent,
      AboutComponent,
      NetworkComponent,
      MapComponent,
      ContactComponent,
      LinkedinFeedComponent,
      IntroScreenComponent
    ])
  ],
  providers: [
    StoryblokService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
